'use client'

import { memo, type PropsWithChildren } from 'react'

const DashboardPageLayout = ({ children }: PropsWithChildren) => {
  // `pt-lg` (24px) gives the identity card breathing room from the sticky mobile
  // nav (a flat `p-sm` left only 12px up top, which read as cramped); `lg`
  // restores the larger desktop padding. `gap-md` tightens the mobile rhythm
  // around the tab bar (gap-lg above/below the tabs read as too much whitespace
  // on mobile); desktop follows the mockup's flat 48px rhythm between blocks.
  return (
    <div className="lg:pt-lg lg:px-xl lg:pb-lg gap-md p-sm pt-lg flex w-full flex-col lg:gap-12">
      {children}
    </div>
  )
}

export default memo(DashboardPageLayout)
